import { createAction, createReducer } from 'redux-act';
import { API_INSTANCE } from '../../utils/service-http';
import { getAppLocale } from '../../utils/app-locale';
import { api_base_url } from '../../constants';
import { appConfiguration } from '../../utils/app-starter';

/**
 * Reducer and action used to retrieve the questions (aggregated by category)
 * to be asked to the user, from AWS.
 */

const questionCache = {};

const DEFAULT_QUESTION_RETRIEVE_STATE = { aggregatedQuestions: [], isLoading: false, error: null };

export const getQuestionsStarted = createAction('GET_QUESTIONS_STARTED');
export const getQuestionsSuccess = createAction('GET_QUESTIONS_SUCCESS');
export const getQuestionsFailed = createAction('GET_QUESTIONS_FAILED');

export const getQuestionsReducer = createReducer(function (on, off) {
  on(getQuestionsStarted, (state, payload) => {
    return {
      aggregatedQuestions: [],
      isLoading: true,
      error: null,
    }
  });
  on(getQuestionsSuccess, (state, payload) => {
    return {
      aggregatedQuestions: payload.aggregatedQuestions,
      isLoading: false,
      error: null,
    }
  });
  on(getQuestionsFailed, (state, payload) => {
    return {
      aggregatedQuestions: [],
      isLoading: false,
      error: null,
    }
  });
}, DEFAULT_QUESTION_RETRIEVE_STATE);

export const getQuestions = (questionType) => {
  return async dispatch => {

    const cachedQuestions = questionCache[questionType];
    if (cachedQuestions) {
      dispatch(getQuestionsSuccess(cachedQuestions));
      return cachedQuestions;
    }

    dispatch(getQuestionsStarted());
    const mainOverrideString = appConfiguration.main ? `&main=${appConfiguration.main}` : '';

    return API_INSTANCE.get(`${api_base_url}/questions?type=${questionType}&locale=${getAppLocale()}${mainOverrideString}`)
      .then((success) => {
        dispatch(getQuestionsSuccess(success.data.payload));
        questionCache[questionType] = success.data.payload;
        return success.data.payload;
      }).catch((error) => {
        dispatch(getQuestionsFailed(error.message));
        throw error;
      });
  }

}






